module.exports = __webpack_public_path__ + "static/media/ribbon.09f87775.webp";